
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_ntpg7_185",
  "arrow-outer": "awsui_arrow-outer_xjuzf_ntpg7_189",
  "arrow-inner": "awsui_arrow-inner_xjuzf_ntpg7_189",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_ntpg7_220",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_ntpg7_220",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_ntpg7_223",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_ntpg7_223",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_ntpg7_226",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_ntpg7_226",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_ntpg7_226",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_ntpg7_226",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_ntpg7_229",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_ntpg7_229",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_ntpg7_229",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_ntpg7_229",
  "body": "awsui_body_xjuzf_ntpg7_325",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_ntpg7_363",
  "has-dismiss": "awsui_has-dismiss_xjuzf_ntpg7_367",
  "dismiss": "awsui_dismiss_xjuzf_ntpg7_372",
  "dismiss-control": "awsui_dismiss-control_xjuzf_ntpg7_379",
  "header-row": "awsui_header-row_xjuzf_ntpg7_383",
  "header": "awsui_header_xjuzf_ntpg7_383",
  "content": "awsui_content_xjuzf_ntpg7_409",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_ntpg7_417",
  "container": "awsui_container_xjuzf_ntpg7_513",
  "container-body": "awsui_container-body_xjuzf_ntpg7_521",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_ntpg7_560",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_ntpg7_565",
  "fixed-width": "awsui_fixed-width_xjuzf_ntpg7_568",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_ntpg7_572",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_ntpg7_579",
  "container-arrow": "awsui_container-arrow_xjuzf_ntpg7_591",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_ntpg7_595",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_ntpg7_595",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_ntpg7_607",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_ntpg7_607",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_ntpg7_619",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_ntpg7_619",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_ntpg7_619",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_ntpg7_619",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_ntpg7_635",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_ntpg7_639",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_ntpg7_643",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_ntpg7_1",
  "refresh": "awsui_refresh_xjuzf_ntpg7_761",
  "root": "awsui_root_xjuzf_ntpg7_783",
  "trigger": "awsui_trigger_xjuzf_ntpg7_819",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_ntpg7_826",
  "trigger-inner-text": "awsui_trigger-inner-text_xjuzf_ntpg7_855",
  "popover-content": "awsui_popover-content_xjuzf_ntpg7_859"
};
  